/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { baseStyles, property, assignSlotNames, state } from '@cds/core/internal';
import styles from './control-message.element.scss';
/**
 * Control Message
 *
 * ```typescript
 * import '@cds/core/forms/register.js';
 * ```
 *
 * ```html
 * <cds-control>
 *   <label>Test</label>
 *   <input type="text" />
 *   <cds-control-message>helper text</cds-control-message>
 * </cds-control>
 * ```
 *
 * @element cds-control-message
 * @slot - For projecting helper message text
 * @cssprop --color
 * @cssprop --font-size
 * @cssprop --font-weight
 * @cssprop --max-width
 * @cssprop --min-width
 */
export class CdsControlMessage extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Set the status of form control message validation
         * @type {neutral | error | success}
         */
        this.status = 'neutral';
        this.disabled = false;
    }
    render() {
        return html `
      <div class="private-host">
        <slot></slot>
      </div>
    `;
    }
    static get styles() {
        return [baseStyles, styles];
    }
    connectedCallback() {
        super.connectedCallback();
        assignSlotNames([this, 'message']);
    }
}
__decorate([
    property({ type: String })
], CdsControlMessage.prototype, "status", void 0);
__decorate([
    property({ type: String })
], CdsControlMessage.prototype, "error", void 0);
__decorate([
    state({ type: Boolean, reflect: true })
], CdsControlMessage.prototype, "disabled", void 0);
